import React from 'react'

const CheckoutSectionHeader = ({ label }) => (
  <div className="card-header"><header><h4>{label}</h4></header></div>
)

export default CheckoutSectionHeader


// WEBPACK FOOTER //
// ./src/Components/checkout/components/Layout/CheckoutSectionHeader.jsx